export const USERS = "users";
export const ESHOPS = "shops";
export const LOCKER = "locker";
export const SNACKMAGIC = "snackmagic";
export const SWAGMAGIC = "swagmagic";
export const SUPERIORDISHES = "superiordishes";
export const STORES = "stores";

export const BYSTADIUM_SITENAMES = [USERS, ESHOPS, LOCKER, STORES];
